export default __webpack_public_path__ + "static/media/affligem_background_s2.c493f728.jpg";